<template>
  <!-- 收付款统计  应收-回款/实收 -->
  <div class="home-pannel concented" style="height: 100%;">
    <div class="home-pannel-title titleed">
      <span>收款数据统计</span>
      <div class="titleed-sele" style="margin-left: 10px;">
        <queryView @select="timeSelect" />
      </div>
      <a-tooltip>
        <template slot="title">切换</template>
        <a-button type="primary" shape="circle" class="changeIcon" @click="changeTanOrChart">
          <a-icon type="swap" style="fontSize:18px;paddingTop:4px;" />
        </a-button>
      </a-tooltip>
    </div>
    <div style="height: 86%;">
      <a-row
        v-show="countPosition === 'top' && showValue === 'chart'"
        style="margin-top: 10px;height:100%;"
      >
        <a-row>
          <a-col v-for="(item,index) in jbkbList" :key="index">
            <a-col v-for="(el, ind) in item" :key="ind" :span="6" style="text-align:center;">
              <span v-if="el.slot" class="jineValue">
                <span
                  :style="el.color ? `color:${el.color}` : ''"
                >{{setJine(jbkbDataObj[el.value])}}</span>
              </span>
              <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
              <br />
              <span :style="el.color ? `color:${el.color}` : ''">
                {{el.name}}
                <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
              </span>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <div id="barId" :style="'width: 96%;height:'+ echartsHeight" />
          </a-col>
        </a-row>
      </a-row>
      <div v-show="showValue === 'table'" class="tableView">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :loading="tableLoadding"
          :pagination="tablePagination"
          :rowKey="(record,index)=>{return index}"
          :scroll="{ y: 240, x: 820 }"
          size="small"
          style="width:100%;"
          @change="pageChange"
          bordered
        >
          <template slot="subjectSlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{ record.subject }}</template>
              <span class="onClickStyle" @click="viewClick(record, 'subject')">{{ record.subject }}</span>
            </a-tooltip>
          </template>
          <template slot="contractSlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{ record.contractTitle }}</template>
              <span
                class="onClickStyle"
                @click="viewClick(record, 'contract')"
              >{{ record.contractTitle }}</span>
            </a-tooltip>
          </template>
          <template slot="contractMoneySlot" slot-scope="text, record">
            <span>￥{{ parseFloat(record.contractMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
          </template>
          <template slot="planMoneySlot" slot-scope="text, record">
            <span>￥{{ parseFloat(record.planMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
          </template>
          <template slot="backMoneySlot" slot-scope="text, record">
            <span>￥{{ parseFloat(record.backMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
          </template>
          <template slot="overMoneySlot" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.overMoney}}</template>
              <span
                v-if="record.overMoney>0"
                style="color:red;font-weight:bold;"
              >￥{{ parseFloat(record.overMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
              <span
                v-else
              >￥{{ parseFloat(record.overMoney).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </a-tooltip>
          </template>
        </a-table>
      </div>
    </div>
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>

<script>
import clickView from '@/components/view/clickView.vue'
import * as echarts from 'echarts'
import queryView from '../queryView.vue'
import { setJine, setUnit } from '@/utils/index.js'
export default {
  index: 'ReceiptAndPayment',
  components: { queryView, clickView },
  props: {
    countPosition: {
      type: String,
      default: 'right'
    },
    echartsHeight: {
      type: String,
      default: '350px'
    }
  },
  data () {
    return {
      clickViewVisible: false,
      myBar: null,
      showValue: 'chart',
      tableLoadding: false,
      tablePagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      tableData: [],
      columns: [
        {
          width: 150,
          title: '项目名称',
          dataIndex: 'subject',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'subjectSlot' }
        },
        {
          width: 150,
          title: '合同名称',
          dataIndex: 'contractTitle',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'contractSlot' }
        },
        {
          width: 100,
          title: '负责人',
          dataIndex: 'dutyPersonName',
          align: 'left',
          ellipsis: true
        },
        {
          width: 120,
          title: '合同金额(元)',
          dataIndex: 'contractMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'contractMoneySlot' }
        },
        {
          width: 120,
          title: '应收金额(元)',
          dataIndex: 'planMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'planMoneySlot' }
        },
        {
          width: 120,
          title: '回款金额(元)',
          dataIndex: 'backMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'backMoneySlot' }
        },
        {
          title: '逾期金款(元)',
          dataIndex: 'overMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'overMoneySlot' }
        }
      ],
      jbkbList: [
        [
          {
            name: '应收总金额',
            value: 'sum',
            slot: 'jine'
          },
          {
            name: '回款金额',
            value: 'moneyCount',
            slot: 'jine'
          }
        ],
        [
          {
            name: '30内到期额',
            value: 'thirtySum',
            slot: 'jine',
            color: '#faad14'
          },
          {
            name: '超期未回款',
            value: 'overSum',
            slot: 'jine',
            color: '#f5222d'
          }
        ]
      ],
      jbkbDataObj: {},
      chartData: null,
      timeQueryVal: 1
    }
  },
  mounted () {
    this.initEchartData()
    this.initTableData()
  },
  methods: {
    setJine,
    setUnit,
    timeSelect (timeVal) {
      this.timeQueryVal = timeVal
      this.tablePagination.current = 1
      this.tablePagination.pageNum = 1
      this.tablePagination.pageSize = 10
      this.initEchartData()
      this.initTableData()
    },
    initTableData () {
      let pramsObj = {
        pageSize: this.tablePagination.pageSize,
        pageNum: this.tablePagination.pageNum,
        timeCondition: this.timeQueryVal
      }
      this.$get('payBack/backCountPage', pramsObj).then(res => {
        if (res.data.status === 1) {
          this.tableData = res.data.data.records
          this.tablePagination.total = res.data.data.total
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    initEchartData () {
      this.$get('payBack/backCount', { timeCondition: this.timeQueryVal }).then(res => {
        if (res.data.status === 1) {
          this.chartData = res.data.data.list
          this.jbkbDataObj = {
            sum: res.data.data.sum,
            thirtySum: res.data.data.thirtySum,
            overSum: res.data.data.overSum,
            moneyCount: res.data.data.moneyCount
          }
          this.setBar()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    viewClick (rowVal, val) {
      if (val === 'contract') {
        if (rowVal.contractId) {
          this.clickViewVisible = true
          this.$refs.clickViewRef.openView('contract', rowVal, rowVal.contractId)
        }
      } else if (val === 'subject') {
        if (rowVal.projectId) {
          this.clickViewVisible = true
          this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
        }
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    changeTanOrChart () {
      if (this.showValue === 'chart') {
        this.showValue = 'table'
      } else if (this.showValue === 'table') {
        this.showValue = 'chart'
        this.setBar()
      }
    },
    pageChange (pageVal) {
      this.tablePagination.current = pageVal.current
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
      this.initTableData()
    },
    setBar () {
      this.myBar = this.$echarts.init(document.getElementById('barId'))
      let xLabel = []
      let dataValue = []
      let dataValue1 = []
      if (this.chartData && this.chartData.length > 0) {
        this.chartData.forEach(element => {
          xLabel.push(element.date)
          dataValue.push(element.height1st)
          dataValue1.push(element.height2nd)
        })
      }
      const barOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: 'rgb(126,199,255)'
            }
          }
        },
        legend: {
          show: true,
          top: '4%',
          itemWidth: 30, // 图例标记的图形宽度。
          //   itemGap: 20, // 图例每项之间的间隔。
          itemHeight: 10, //  图例标记的图形高度。
          textStyle: {
            color: '#000',
            fontSize: 14,
            padding: [0, 8, 0, 8]
          }
        },
        grid: {
          top: '20%',
          left: '10%',
          right: '6%',
          bottom: '10%'
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              // 坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: 'rgb(41,188,245)'
              }
            },
            axisLabel: {
              // 坐标轴刻度标签的相关设置
              textStyle: {
                color: '#000',
                fontSize: 12
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#233653'
              }
            },
            axisTick: {
              show: false
            },
            data: xLabel
          }
        ],
        yAxis: [
          {
            name: '',
            nameTextStyle: {
              color: '#000',
              fontSize: 12,
              padding: [0, 60, 0, 0]
            },
            // minInterval: 1,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#1160a0',
                type: 'dashed'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#008de7'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000',
                fontSize: 14
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '应收款',
            type: 'line',
            symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: '#00ffa2' // 线条颜色
              }
            },
            itemStyle: {
              normal: {
                color: '#00f0ff', // 拐点颜色
                // borderColor: '#fff600',//拐点边框颜色
                // borderWidth: 13//拐点边框大小
                label: {
                  show: false, // 开启显示
                  color: '#09c782',
                  position: 'top', // 在上方显示
                  formatter: function (res) {
                    if (res.value) {
                      return res.value
                    } else {
                      return 0
                    }
                  }
                }
              }

            },
            symbolSize: 8, // 设定实心点的大小
            areaStyle: {
              normal: {
                // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#00ffa230'
                    },
                    {
                      offset: 0.6,
                      color: '#00ffa220'
                    },
                    {
                      offset: 1,
                      color: '#00ffa210'
                    }
                  ],
                  false
                )
              }
            },
            data: dataValue
          },
          {
            name: '实收款',
            type: 'line',
            symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: '#5DD6FC' // 线条颜色
              }
            },
            itemStyle: {
              normal: {
                color: '#00C1FF', // 拐点颜色
                // borderColor: '#fff600',//拐点边框颜色
                // borderWidth: 13//拐点边框大小
                label: {
                  show: false, // 开启显示
                  color: '#1890ff',
                  position: 'top', // 在上方显示
                  formatter: function (res) {
                    if (res.value) {
                      return res.value
                    } else {
                      return 0
                    }
                  }
                }
              }

            },
            symbolSize: 8, // 设定实心点的大小
            areaStyle: {
              normal: {
                // 线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#CBF0FF'
                    },
                    {
                      offset: 0.6,
                      color: '#DEF5FC'
                    },
                    {
                      offset: 1,
                      color: '#EAF5FA'
                    }
                  ],
                  false
                )
              }
            },
            data: dataValue1
          }
        ]
      }
      this.myBar.setOption(barOption, true)
    }
  }
}
</script>

<style lang="less" scoped>
.changeIcon {
  position: absolute;
  right: 20px;
  top: 8px;
}
.tableView {
  width: 100%;
  height: 96%;
  padding: 6px;
}
.jineValue {
  color: #4b9de1;
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/second/receiptAndPayment.vue